var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 785,
    height: 589,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M542.825 172.118c-54.172-50.86-117.64-63.99-134.41-66.669 11.302-30.53 28.758-75.913 33.105-82.628a62.562 62.562 0 0 1 8.477-.486c12.322 0 38.706 2.563 76.911 19.761 55.175 24.836 69.839 52.77 72.748 59.602l-56.831 70.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0C6F4",
    d: "M449.997 25.685c12.055 0 37.904 2.528 75.49 19.46 49.842 22.473 65.943 47.593 70.223 56.084l-53.202 65.999a269.221 269.221 0 0 0-90.421-53.824 249.664 249.664 0 0 0-39.091-10.601c12.49-33.61 26.066-68.21 30.631-76.85a71.38 71.38 0 0 1 6.403-.268h-.033Zm.033-6.699a56.462 56.462 0 0 0-10.148.703c-3.913 1.307-36.015 88.49-36.015 88.49s76.192 7.787 139.31 68.862l60.191-74.724s-10.032-33.928-75.239-63.268c-38.172-17.2-64.773-20.096-78.232-20.096l.133.033Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M415.019 114.961s74.922 7.57 121.068 50.023"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0C6F4",
    d: "m479.691 111.294 27.956-54.427 28.725 56.755-56.681-2.328Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m485.125 110.523 27.956-54.426 28.724 56.754-56.68-2.328ZM458.909 15.67s84.033 7.637 136.199 69.733"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M501.828 256.856a382.607 382.607 0 0 1-7.64-5.677c1.27-1.675 21.484-23.262 33.188-40.645 0 0-23.675 47.712-25.548 46.322Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M215.435 99.655c2.257 3.768 3.243 2.26 9.747 1.674 6.504-.586 15.767 4.254 19.011 12.276 3.243 8.021 2.257 9.261.501 10.265-1.755 1.005-14.245 2.512-14.747 5.024"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9865F",
    d: "m383.92 507.369-5.835-9.864-20.666 34.515 5.418 4.187 21.083-28.838ZM246.667 421.878s-10.717-17.434-6.119-25.991l34.175 3.667-28.056 22.324Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m246.667 421.878 2.04 4.722-6.303 24.651a8.38 8.38 0 0 0 2.658 8.491l31.25-46.271a10.804 10.804 0 0 0-1.589-13.917l-6.989-6.497-21.067 28.821Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A1E33",
    d: "M229.948 128.961c9.781-.234 22.187-.854 19.696-8.373-2.492-7.519-11.704-26.074-32.855-20.498 0 0-7.44 6.213 1.856 17.4 9.296 11.187 11.303 11.471 11.303 11.471Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B3B5F",
    d: "M279.472 399.889s-16.72-49.402-2.575-71.089c11.704-17.902 49.791 11.203 55.008 15.072l27.27-49.269s-6.287-8.842-21.736-17.5c-15.449-8.658-79.302-34.582-109.314 12.844-11.085 17.518-11.252 92.727 10.032 121.548l41.315-11.606Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M279.472 399.889s-16.72-49.402-2.575-71.089c11.704-17.903 49.791 11.203 55.008 15.072"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B3B5F",
    d: "M359.175 294.603c-12.406 13.079-49.173 76.783-57.449 107.179-11.052 40.728-6.889 74.506 53.904 140.672l29.377-42.872s-20.666-31.417-16.72-61.041c5.585-42.855 36.031-84.404 51.43-110.763l-60.542-33.175Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C3C6C",
    d: "m363.84 300.129 48.872 38.434 14.613-22.24-63.485-16.194Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8A66",
    d: "M644.599 259.736c7.624 1.641 13.431 4.55 17.422 8.725 3.996 4.187 2.19 6.364.736 7.637-1.455 1.272-7.09-.185-11.989-4.539-4.898-4.354-6.169-11.823-6.169-11.823Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9865F",
    d: "M494.188 251.179c1.27-1.675 21.484-23.262 33.188-40.645 0 0 35.363 39.69 39.208 40.98 1.421.468 10.032.351 20.867.251 18.191-.201 42.384-.385 47.735 2.311 8.527 4.253 13.643 6.397 15.766 12.376 2.124 5.978 2.977 9.88-2.123 10.232-5.969.435-9.798-7.252-9.798-7.252a119.886 119.886 0 0 1-17.505 7.687s-45.328 17.618-75.624 9.094c-8.243-2.328-51.714-35.034-51.714-35.034ZM219.431 92.638c-3.879 1.49-6.253 3.266-3.996 7.017 2.257 3.751 3.243 2.261 9.747 1.675 6.504-.587 15.767 4.253 19.011 12.275 3.243 8.022 2.257 9.261.501 10.266-1.755 1.004-14.245 2.512-14.746 5.024-.502 2.512 5.016 9.897 16.569 9.411l2.742-.502s24.193 23.663 27.705 27.163c3.511 3.5 29.226 20.967 43.471 24.517 10.768 2.696 32.604-.77 45.712-3.349 6.37-1.256 10.701-2.278 10.701-2.278s-9.848-17.768-11.855-45.065c0 0-23.541 3.785-39.191 7.234 0 0-36.516-20.397-54.272-29.423 0 0-15.516-19.025-22.773-21.537-7.256-2.512-24.076-4.42-29.326-2.428Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M366.08 186.218c6.37-1.256 10.701-2.277 10.701-2.277s-11.921-15.072-13.911-42.336c0 0-5.384 5.811-3.712 21.268 2.107 19.527 6.922 23.345 6.922 23.345Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#471C36",
    d: "M362.368 138.541s.335 33.376 9.263 47.292l3.194-1.289s-42.051 49.285-55.661 81.489c-2.223 5.275 87.328 62.566 100.553 61.762 0 0 43.639-66.702 58.52-86.48l16.051 12.46s31.45-31.92 33.138-43.24c0 0-30.38-37.027-55.175-47.879-24.796-10.852-47.183-29.407-73.885-28.821-23.107.352-35.998 4.706-35.998 4.706Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m494.221 253.774-16.034-12.459 2.558-6.967 13.476 19.426Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9865F",
    d: "M518.632 121.827c-2.809 8.759-10.918 34.063-19.964 37.178-9.045 3.115-18.391-.787-18.391-.787l-9.631 4.923c-1.07 3.232-8.678 6.012-18.492 6.398-7.273.284-11.704-9.077-9.547-15.843.986-3.115 4.681-18.421 4.681-18.421s7.792-28.737 15.048-34.666c7.257-5.928 13.911-11.823 33.055-4.07 29.16 11.857 23.241 25.288 23.241 25.288Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A1E33",
    d: "M460.497 123.083c-1.287 5.359-6.855 16.111-10.517 14.168-3.661-1.942-4.932-6.866-2.357-16.328s4.731-30.931 12.021-34.8c7.29-3.868 10.517.637 10.517.637s-3.227-15.675 6.22-17.835c0 0 3.21-1.49 1.923 9.244 1.25-2.952 3.45-5.4 6.249-6.957a14.343 14.343 0 0 1 9.2-1.634c11.704 1.29 15.867 17.835 15.867 17.835a5.979 5.979 0 0 1 2.287-3.397 5.96 5.96 0 0 1 3.933-1.125c5.367 0 13.526 7.955 11.586 16.747 0 0 13.727-4.304 21.017 6.699 7.29 11.002 6.437 22.993-11.152 27.716-18.392 4.94-18.224-16.546-21.017-19.343-2.792-2.797-5.785-6.012-16.084-2.143-10.3 3.868-21.034-7.52-21.034-7.52s-1.672 13.749-3.427 15.072c-1.756 1.323-5.15 3.015-4.297-3.433.852-6.447 1.939-5.811 1.287-7.519-.652-1.708-3.544-7.151-9.647-2.361-6.855 5.258-2.575 16.277-2.575 16.277Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A1E33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M463.423 125.461c-4.096-3.349-6.939-9.512-3.344-15.574 3.595-6.062 9.497-6.883 11.286-4.589 1.789 2.295 2.491 6.163.802 10.752"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m362.853 536.207 2.04 4.706-6.303 24.651a8.38 8.38 0 0 0 2.658 8.491l31.216-46.272a10.788 10.788 0 0 0 1.768-7.251 10.793 10.793 0 0 0-3.356-6.665l-6.989-6.498-21.034 28.838Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A1E33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M470.161 86.76s-2.408-7.788-9.58-9.847"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m318.094 263.672 86.576-121.129M440.366 151.017c-3.126 4.069-4.547 21.553 9.815 22.675a38.78 38.78 0 0 0 23.525-5.175M248.674 95.15s9.898 13.113 11.453 17.785M619.252 271.04s6.687 5.443 19.779-1.675c4.765-2.562 1.371-8.607-4.681-7.1-6.053 1.507-13.209-.754-13.209-.754M646.873 260.49s6.337 7.419 6.169 11.823M553.509 259.686s5.735-7.653 13.075-8.172M311.657 158.469s3.344-10.45 14.078-12.359M340.733 317.027l-12.807 24.467s-42.201 71.525-27.872 117.745M378.118 399.085l41.516-71.29s54.423-79.061 59.99-90.131l19.212-35.587"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M323.913 271.275s73.851 53.924 95.737 56.52M362.368 138.541s0 33.845 9.046 47.711M525.002 205.175c-2.324 13.934-33.139 43.224-33.139 43.224"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M295.004 378.872a4.384 4.384 0 0 0 4.381-4.388 4.384 4.384 0 0 0-4.381-4.387 4.383 4.383 0 0 0-4.38 4.387 4.384 4.384 0 0 0 4.38 4.388Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m706.379 468.852-2.425-16.797 14.296 9.529-7.474 1.624-4.397 5.644ZM231.954 182.099c-27.103-23.965-71.895 35.771 91.959 225.912 94.55 109.691 168.87 119.521 178.902 81.356 18.057-68.461-47.15-85.76-22.873-58.949 35.279 38.987 135.614 47.226 210.402 10.852 73.785-35.905 28.424-91.654 23.843-94.92"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M691.582 445.306a4.383 4.383 0 0 0 4.38-4.387 4.384 4.384 0 0 0-4.38-4.388 4.384 4.384 0 0 0-4.381 4.388 4.384 4.384 0 0 0 4.381 4.387Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m627.779 476.773 129.963-73.384"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M234.663 190.037a4.384 4.384 0 0 0 4.38-4.388 4.384 4.384 0 0 0-4.38-4.388 4.384 4.384 0 0 0-4.381 4.388 4.384 4.384 0 0 0 4.381 4.388Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D66",
    d: "M346.468 104.394c5.199 0 9.413-4.221 9.413-9.428 0-5.207-4.214-9.429-9.413-9.429s-9.413 4.221-9.413 9.429c0 5.207 4.214 9.428 9.413 9.428Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0C6F4",
    d: "M175.792 23.106a4.14 4.14 0 0 0-2.308.692 4.157 4.157 0 0 0 1.476 7.533 4.14 4.14 0 0 0 4.262-1.763 4.161 4.161 0 0 0-.509-5.24 4.142 4.142 0 0 0-2.921-1.222Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD8B0",
    d: "M729.87 537.53a4.133 4.133 0 0 0 4.13-4.136 4.133 4.133 0 0 0-4.13-4.137 4.133 4.133 0 0 0-4.13 4.137 4.133 4.133 0 0 0 4.13 4.136Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A1E33",
    d: "m655.985 346.333-44.491-20.883a4.636 4.636 0 0 1-2.579-4.223 4.645 4.645 0 0 1 2.696-4.15l82.696-36.441a4.534 4.534 0 0 1 3.678 0l56.848 24.417-98.848 41.28Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M653.293 277.672c.1 18.421 2.742 68.662 2.742 68.662l98.848-41.348-2.224-69.917a6.01 6.01 0 0 0-5.616-5.824 5.992 5.992 0 0 0-2.878.532l-85.087 38.852a9.822 9.822 0 0 0-4.234 3.66 9.848 9.848 0 0 0-1.551 5.383Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m655.985 346.333 98.848-41.347-2.224-69.918s-.652-7.636-8.494-5.292M703.82 296.076l6.672-15.792M710.492 296.076l6.671-15.792"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D66",
    d: "M193.599 468.4a4.133 4.133 0 0 0 4.129-4.137 4.133 4.133 0 0 0-4.129-4.136 4.133 4.133 0 0 0-4.13 4.136 4.133 4.133 0 0 0 4.13 4.137ZM542.257 490.556a5.757 5.757 0 0 0 5.751-5.761 5.756 5.756 0 0 0-5.751-5.761 5.756 5.756 0 0 0-5.752 5.761 5.757 5.757 0 0 0 5.752 5.761Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF7DC",
    d: "M236.468 525.707a122.5 122.5 0 0 0 52.216 11.22 2.38 2.38 0 0 1 2.251 1.673c.1.32.13.658.09.99l-3.611 28.67a2.366 2.366 0 0 1-1.957 1.993c-7.323 1.39-36.783 5.443-58.887-13.397a2.347 2.347 0 0 1-.735-2.395l7.289-27.347a2.37 2.37 0 0 1 1.343-1.489 2.348 2.348 0 0 1 2.001.082Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M239.06 534.08s12.74 17.936 17.288 20.515c4.548 2.579 29.093-12.091 29.093-12.091M268.37 552.117l13.392 13.782M249.761 549.454l-15.667 4.27"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE1C0",
    d: "M646.505 186.402h-14.964v14.989h14.964v-14.989Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0C6F4",
    d: "m633.564 388.518 4.447 7.721 4.448 7.72h-17.773l4.43-7.72 4.448-7.721Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m274.004 46.752 1.171-35.034c-.134-3.35 1.203-4.304 3.21-4.756 9.497-2.093 38.455-8.54 69.772.754 4.062 1.205 3.929 3.349 3.862 5.292l-1.12 33.392a4.52 4.52 0 0 1-1.9 3.12 4.498 4.498 0 0 1-3.584.682 243.717 243.717 0 0 0-34.309-1.675 194.388 194.388 0 0 0-32.905 2.663c-3.11.586-4.28-1.691-4.197-4.438Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m284.571 41.728 18.292-21.436 20.231 20.012c-6.989-2.36-38.523 1.424-38.523 1.424ZM314.048 30.14l14.781-11.857 12.456 8.909.468 13.916-18.676-.904M292.472 18.614c.17-1.684-1.294-3.211-3.269-3.411-1.975-.2-3.714 1.003-3.884 2.687-.17 1.684 1.294 3.211 3.269 3.41 1.975.2 3.714-1.002 3.884-2.686ZM627.461 501.776l12.256 22.675c1.287 2.026.836 3.182-.285 4.22-5.25 4.873-21.25 19.711-44.658 25.505-3.026.754-3.745-.67-4.414-1.926l-11.704-21.619a3.354 3.354 0 0 1 2.073-4.472 175.872 175.872 0 0 0 22.405-11.723 142.42 142.42 0 0 0 20.063-13.849c1.672-1.675 3.344-.586 4.264 1.189Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m622.646 508.96-3.662 20.415-20.264-5.175c5.266-1.139 23.926-15.24 23.926-15.24ZM608.183 527.248l-4.999 13.028-11.202-1.021-5.468-8.675 12.189-6.38M629.443 527.599c1.327-.607 1.986-2.014 1.472-3.141-.515-1.127-2.007-1.548-3.334-.941-1.327.607-1.986 2.013-1.472 3.141.515 1.127 2.007 1.548 3.334.941Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m567.771 114.626 49.809 38.183a2.458 2.458 0 0 0 3.477-.486l7.524-10.216a2.446 2.446 0 0 0-.451-3.349l-49.106-39.371a2.462 2.462 0 0 0-1.868-.515 2.46 2.46 0 0 0-1.66 1l-8.226 11.388a2.444 2.444 0 0 0 .501 3.366Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D66",
    d: "m571.45 112.918 12.071 8.491 7.14-8.524-12.089-10.099-7.122 10.132Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD8B0",
    d: "m588.069 124.725 12.105 9.612 6.488-7.988-12.189-9.897-6.404 8.273Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0C6F4",
    d: "m604.237 138.021 12.089 8.491 5.751-7.402-11.436-9.596-6.404 8.507Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m667.171 61.238 11.352 95.456a3.79 3.79 0 0 0 1.415 2.576 3.766 3.766 0 0 0 2.832.773l19.228-2.646a3.754 3.754 0 0 0 3.227-4.103l-9.313-96.025a3.76 3.76 0 0 0-1.433-2.596 3.75 3.75 0 0 0-2.864-.753l-21.251 3.114a3.77 3.77 0 0 0-3.193 4.203Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D66",
    d: "m672.972 63.465 3.595 22.34 16.954-1.256-1.856-24.065-18.693 2.981Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#91BA83",
    d: "m677.788 94.346 2.391 23.562 15.683-1.406-2.174-23.948-15.9 1.792Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD8B0",
    d: "m680.48 126.332 3.594 22.34 14.262-1.574-1.722-22.826-16.134 2.06Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m642.392 81.568 31.433 92.559a3.006 3.006 0 0 0 1.534 1.738 2.987 2.987 0 0 0 2.312.121l19.696-7.1a3.018 3.018 0 0 0 1.839-3.735l-29.511-93.463a3.022 3.022 0 0 0-1.548-1.793 3.007 3.007 0 0 0-2.364-.116L644.181 77.8a2.962 2.962 0 0 0-1.789 3.768Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0C6F4",
    d: "m648.762 83.26 8.159 21.117 16.319-4.772-6.805-23.161-17.673 6.816Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9865F",
    d: "m659.897 112.466 7.223 22.558 15.048-4.656-7.089-22.976-15.182 5.074Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD8B0",
    d: "m669.16 143.196 8.159 21.101 13.627-4.522-6.42-21.971-15.366 5.392Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#7595EC",
    d: "M405.472 198.477H246.718c-5.061 0-9.163 4.109-9.163 9.177v21.52c0 5.068 4.102 9.177 9.163 9.177h158.754c5.06 0 9.163-4.109 9.163-9.177v-21.52c0-5.068-4.103-9.177-9.163-9.177Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M345.983 210.216h-86.542a3.029 3.029 0 0 0-3.026 3.031 3.029 3.029 0 0 0 3.026 3.032h86.542a3.029 3.029 0 0 0 3.026-3.032 3.029 3.029 0 0 0-3.026-3.031Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M257.284 224.149h147.118"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#91BA83",
    d: "m182.008 123.451 2.503 2.745a2.846 2.846 0 0 1-.181 4.022l-4.099 3.75a2.84 2.84 0 0 1-4.016-.182l-2.503-2.745 8.296-7.59Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m159.465 118.115 11.807 12.946c.61.669 1.646.716 2.315.105l8.159-7.466a1.64 1.64 0 0 0 .105-2.318l-11.806-12.946a1.637 1.637 0 0 0-2.315-.105l-8.16 7.466a1.643 1.643 0 0 0-.105 2.318Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D66",
    d: "M147.134 176.941h-14.83v13.564h14.83v-13.564Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M132.304 168.215v8.725h-8.862"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD8B0",
    d: "M635.771 23.759H620.94v13.565h14.831V23.759Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M620.94 15.034v8.725h-8.861M219.531 107.609C65.709 43.771-52.601 166.725 237.237 354.991c22.823 14.838 57.834 20.096 57.834 20.096"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78.098 116.284c2.42 0 4.38-1.964 4.38-4.387a4.385 4.385 0 0 0-4.38-4.388 4.385 4.385 0 0 0-4.38 4.388 4.384 4.384 0 0 0 4.38 4.387Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m50.21 87.798 4.798-4.622 11.018 6.33 5.552 17.132-16.938-7.1-4.43-11.74Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m55.008 83.176-4.798 4.622-2.692-3.266 4.598-4.42 2.892 3.064ZM71.578 106.638 60.559 94.53"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m98.195 414.074 11.938 61.694a2.475 2.475 0 0 0 2.926 1.943l12.406-2.646a2.46 2.46 0 0 0 1.906-2.83l-10.6-62.08a2.454 2.454 0 0 0-1.057-1.623 2.467 2.467 0 0 0-1.902-.353l-13.694 3.048a2.413 2.413 0 0 0-1.55 1.024 2.423 2.423 0 0 0-.373 1.823Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D66",
    d: "m102.125 415.246 3.41 14.385 10.969-1.624-2.341-15.591-12.038 2.83Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAD8B0",
    d: "m106.739 435.141 2.675 15.223 10.149-1.658-2.558-15.508-10.266 1.943Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#A0C6F4",
    d: "m110.016 455.84 3.394 14.385 9.213-1.724-2.19-14.771-10.417 2.11Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m440.467 568.662 50.494-13.531 1.939 5.476-51.079 13.28-1.354-5.225ZM433.444 561.595l1.472 4.589M432.023 564.592l4.264-1.473M431.003 579.129l2.742 8.675M428.663 584.622l7.59-2.412M419.45 564.827l3.595 11.488M415.889 571.978l10.633-3.4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.67,
    d: "M72.18 19.103 40.227 4.651 41.548 1l32.153 14.82-1.522 3.283ZM72.832 25.768l1.187-3.014M74.838 24.814l-2.842-1.055M81.526 17.696l2.257-5.66M85.07 15.838l-4.949-1.976M81.459 30.039l3.01-7.486M86.341 27.845l-6.955-2.763"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M191.643 289.478c-22.539-16.244-44.676-41.498-34.962-67.439 0 0 15.533-10.366 40.128 2.596l24.612 13.029-29.778 51.814Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M181.427 397.712c-10.149-4.806-53.42-27.381-61.128-65.948-6.688-33.293 18.793-78.224 31.534-98.086-.82 26.343 25.598 48.65 38.338 57.827a136.226 136.226 0 0 0 35.496 18.79l-44.24 87.417Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M149.893 241.516c2.759 17.517 16.101 35.654 38.807 52.032a135.89 135.89 0 0 0 33.439 18.103L180.34 394.38c-12.774-6.364-50.511-27.9-57.55-63.102-5.835-29.256 13.961-68.058 27.137-89.762h-.034Zm6.822-19.476s-47.902 64.843-38.84 110.226c9.062 45.384 64.739 68.662 64.739 68.662l46.598-92.107c-14.563-5.342-24.026-9.696-37.536-19.443-22.538-16.244-44.675-41.498-34.961-67.439v.101Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M144.091 259.719a55.636 55.636 0 0 0 9.727 23.368 55.503 55.503 0 0 0 19.065 16.623M186.794 309.022l25.999 13.95M147.803 296.93s8.36 18.606 35.279 30.697M126.435 299.711s.937 19.543 13.928 26.058M156.163 231.82s-2.408 25.12 35.479 57.659M170.091 236.475s12.071-.938 29.711 12.091M113.243 316.558c-.769 12.443.786 57.541 65.993 86.312"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m529.684 291.471-27.655 55.516s18.76 6.916 4.096 28.469c0 0 34.677 14.402 57.366-22.993 22.689-37.396-33.807-60.992-33.807-60.992Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M466.382 461.148c-13.994 0-28.758-5.727-43.923-17.031l51.732-85.877 30.781 19.409.2.084a47.472 47.472 0 0 0 16.804 2.914 46.265 46.265 0 0 0 27.136-8.591l-37.82 64.893c-.084.118-16.369 24.25-44.91 24.25v-.051Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m475.027 361.757 28.423 17.936.368.234.385.151a50.084 50.084 0 0 0 17.773 3.115 49.354 49.354 0 0 0 20.231-4.254l-33.005 56.554c-1.07 1.574-16.386 23.144-42.803 23.144-12.891 0-26.534-5.108-40.612-15.19l49.24-81.69Zm88.464-9.311c-12.824 21.134-29.46 25.723-41.515 25.723a45.213 45.213 0 0 1-15.851-2.73l-32.754-20.649-54.155 89.964c18.091 13.966 33.924 18.99 47.183 18.99 30.28 0 47.066-25.488 47.066-25.488l50.026-85.726v-.084Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M502.029 346.986s20.632 7.302 4.096 28.47"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M472.719 352.848s28.106 25.789 43.656 25.605c15.549-.184 33.807-3.868 44.558-22.457M476.18 386.207s19.278 17.148 40.847 11.639M496.428 411.83s10.115 7.586 24.26.401M449.88 422.414s23.408 23.261 60.108 7.921M462.587 399.722s9.53 6.832 15.499 9.01M534.432 307.581s21.318 6.984 23.876 35.168"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M545.149 342.398s9.815 15.222-6.771 30.428M421.122 440.567s53.503 67.12 92.377-11.371"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF6D66",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M34.744 274.138h12.473M729.87 123.803h12.473"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAD8B0",
    strokeMiterlimit: 10,
    d: "M395.223 38.06h12.49M753.696 188.63l12.272 2.21"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A0C6F4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M263.504 500.503h12.49"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#91BA83",
    d: "M780.581 348.829a4.133 4.133 0 0 0 4.13-4.137 4.133 4.133 0 0 0-4.13-4.136 4.133 4.133 0 0 0-4.13 4.136 4.133 4.133 0 0 0 4.13 4.137ZM4.13 150.18c2.28 0 4.13-1.852 4.13-4.137a4.133 4.133 0 0 0-4.13-4.136A4.133 4.133 0 0 0 0 146.043a4.133 4.133 0 0 0 4.13 4.137Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 150.244,
    x2: 229.354,
    y1: 250.024,
    y2: 250.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 109.878,
    x2: 242.514,
    y1: 301.97,
    y2: 302.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 497.955,
    x2: 576.769,
    y1: 330.243,
    y2: 330.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 410.422,
    x2: 580.551,
    y1: 402.211,
    y2: 403.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA367C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A2FBD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact-img.f7fa17f21fb3aeb71e6e5d1765de456a.svg";
export { ForwardRef as ReactComponent };